import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotRank from "./components/HotRank";
import Archive from "./components/Archive";
import Timeline from "./components/Timeline";
import About from "./components/About";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";
import { faqs } from "@/mocks/gossip";

function ScrollTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 700);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return show ? (
    <a
      href="#top"
      aria-label="回到顶部"
      className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-foreground-900 text-background-50 shadow-lg transition-colors hover:bg-primary-600"
    >
      <i className="ri-arrow-up-line text-lg"></i>
    </a>
  ) : null;
}

export default function Home() {
  return (
    <main>
      {/* FAQ 结构化数据 */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "Organization",
                name: "吃瓜大全",
                url: "https://feixunsl.cn/",
                sameAs: ["https://feixunsl.cn/"],
                description:
                  "吃瓜大全是一份持续更新的娱乐事件资料库，把深度爆料按事件完整归档，按时间线从源头到尾声一页理清。",
              },
              {
                "@type": "WebSite",
                name: "吃瓜大全",
                url: "https://feixunsl.cn/",
                potentialAction: {
                  "@type": "SearchAction",
                  target: "https://feixunsl.cn/?q={search_term_string}",
                  "query-input": "required name=search_term_string",
                },
              },
              {
                "@type": "AboutPage",
                "@id": "https://feixunsl.cn/#about",
                name: "关于吃瓜大全",
                description: "吃瓜大全的品牌定位、内容原则与发展理念。",
                url: "https://feixunsl.cn/#about",
                isPartOf: { "@type": "WebSite", url: "https://feixunsl.cn/" },
              },
              {
                "@type": "WebPage",
                "@id": "https://feixunsl.cn/",
                url: "https://feixunsl.cn/",
                name: "吃瓜大全 - 深度爆料·完整存档，一页理清热点事件全脉络",
                isPartOf: { "@type": "WebSite", url: "https://feixunsl.cn/" },
                about: {
                  "@type": "Organization",
                  name: "吃瓜大全",
                },
              },
              {
                "@type": "FAQPage",
                mainEntity: faqs.map((f) => ({
                  "@type": "Question",
                  name: f.q,
                  acceptedAnswer: { "@type": "Answer", text: f.a },
                })),
              },
            ],
          }),
        }}
      />
      <Navbar />
      <Hero />
      <HotRank />
      <Archive />
      <Timeline />
      <About />
      <FAQ />
      <Footer />
      <ScrollTop />
    </main>
  );
}